<template>
  <DefButtonSecondary class="go-sign-up" @click="goSingUp">
    {{ messages.btnCreateAccount }}
  </DefButtonSecondary>
</template>

<script lang="ts" setup>
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import useModal from '@use/useModal/useModal';
import SignUp from '@components/Cabinet/Entry/SignUp/SignUp.vue';
import { computed } from 'vue';
import { useResultsStore } from '@/storePinia/stores/results';

const resultsStore = useResultsStore();
const modal = useModal();

const messages = computed(() => resultsStore?.messages?.entry);

const goSingUp = () => {
  modal.show(
    SignUp,
    {},
    {
      width: '900px',
      backgroundClose: false,
    }
  );
};
</script>

<style lang="scss" scoped>
.go-sign-up {
  width: 100%;
}
</style>
